import React from 'react'

export default function ThumbsDownFilledIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1349_9966)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.48531 13.0746C5.23621 14.2371 6.1224 15.3333 7.3113 15.3333C7.74057 15.3333 8.1395 15.1122 8.36703 14.7482L11.3346 10L13.3346 10C14.071 10 14.668 9.40307 14.668 8.66667L14.668 3.33333C14.668 2.59695 14.071 2 13.3346 2L11.3346 2L10.0013 2L3.90404 2C3.1465 2 2.45397 2.42801 2.11518 3.10557L0.949495 5.43695C0.764355 5.80723 0.667968 6.21553 0.667968 6.62951L0.667968 8.66667C0.667968 9.77127 1.5634 10.6667 2.66797 10.6667L6.0013 10.6667L5.48531 13.0746ZM11.3346 3.33333L11.3346 8.66667L13.3346 8.66667L13.3346 3.33333L11.3346 3.33333ZM7.26363 13.9979L10.0013 9.6176L10.0013 3.33333L3.90404 3.33333C3.65152 3.33333 3.42068 3.476 3.30776 3.70186L2.14207 6.03323C2.0495 6.21837 2.0013 6.42252 2.0013 6.62951L2.0013 8.66667C2.0013 9.03487 2.29978 9.33333 2.66797 9.33333L6.0013 9.33333C6.40396 9.33333 6.78503 9.51527 7.03817 9.8284C7.2913 10.1415 7.38944 10.5523 7.30503 10.9461L6.78903 13.354C6.72117 13.6707 6.94797 13.9703 7.26363 13.9979Z"
          fill="#EAF6FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.48531 13.0746C5.23621 14.2371 6.1224 15.3333 7.3113 15.3333C7.74057 15.3333 8.1395 15.1122 8.36703 14.7482L11.3346 10L13.3346 10C14.071 10 14.668 9.40307 14.668 8.66667L14.668 3.33333C14.668 2.59695 14.071 2 13.3346 2L3.90404 2C3.1465 2 2.45397 2.42801 2.11518 3.10557L0.949495 5.43695C0.764355 5.80723 0.667968 6.21553 0.667968 6.62951L0.667968 8.66667C0.667968 9.77127 1.5634 10.6667 2.66797 10.6667L6.0013 10.6667L5.48531 13.0746Z"
          fill="#1A91F0"
          stroke="#EAF6FF"
        />
        <path
          d="M11.3346 3.33333L11.3346 8.66667L11.3346 10L11.3346 13L10.0013 13L10.0013 12.1334L10.0013 9.6176L10.0013 3.33333L10.0013 2L11.3346 2L11.3346 3.33333Z"
          fill="#EAF6FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1349_9966">
          <rect width="16" height="16" fill="white" transform="translate(16 16) rotate(-180)" />
        </clipPath>
      </defs>
    </svg>
  )
}
